export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14483.9b404747.jpg";